import { render, staticRenderFns } from "./BackModal.vue?vue&type=template&id=062a9b2d&scoped=true"
import script from "./BackModal.vue?vue&type=script&lang=js"
export * from "./BackModal.vue?vue&type=script&lang=js"
import style0 from "./BackModal.vue?vue&type=style&index=0&id=062a9b2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a9b2d",
  null
  
)

export default component.exports